import styled from 'styled-components';
import colors from 'themes/Main';

const { darkBlue, lightBlue, gray04, gray06 } = colors;

export const CheckboxContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;

  span {
    margin-left: 8px;
  }
`;

export const Label = styled.label`
  margin: 0;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
  width: 16px;
  height: 16px;
`;

export const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 16px;
  height: 16px;
  background: ${({ checked }) => (checked ? darkBlue : gray04)};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${({ checked }) => (checked ? lightBlue : gray06)};
  }

  ${Icon} {
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  }
`;
